module.exports = __webpack_public_path__ + "static/media/location.754a1954.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Teams/Listing/img/location.svg
// module id = 73
// module chunks = 0